import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

const routes: Routes = [
  {path: '', loadChildren: () => import('./templates/templates.module').then(m => m.TemplatesModule)},
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    paramsInheritanceStrategy: 'always',
    onSameUrlNavigation: 'ignore'
})],
  exports: [RouterModule]
})
export class AppRoutingModule {}
